import css from 'styled-jsx/css';
import { fontSizes, colors } from '../../../themes';

export default css`
  .suggestions {
    padding: 0 25px;
    margin-bottom: 1.5em;
  }

  .suggestions-title {
    font-weight: bold;
    font-size: ${fontSizes.normal};
    margin: 0;
    color: ${colors.grayDeep};
  }

  .suggestions-list {
    list-style: none;
    padding: 0;
  }
`;



// WEBPACK FOOTER //
// ./app/Suggestions/components/SuggestionsList/styles.js